module.exports = __webpack_public_path__ + "static/media/design-system-navigation.f129fd16.png";